
import { useParams } from 'react-router-dom';
import { ClienteFormState } from '../../../context/cliente/ClienteFormState';
import { Form } from './formRegister';

export const ClienteRegisterPage = () => {
  const { id } = useParams();

  return (
    <ClienteFormState>
        <br />
        <Form title="Registrarse" />
    </ClienteFormState>
  );
};
